export const DEFAULT_OPEN_TIME = '07:00';
export const DEFAULT_CLOSE_TIME = '21:00';
export const DEFAULT_BREAK_START = '13:00';
export const DEFAULT_BREAK_END = '14:00';

export const DAYS_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const DEFAULT_SCHEDULE = (() => {
    const schedule: any = {};
    DAYS_ORDER.forEach(day => {
        if (day === 'sunday') {
            schedule[day] = { open: null, close: null, start_break: null, end_break: null };
        } else {
            schedule[day] = {
                open: DEFAULT_OPEN_TIME,
                close: DEFAULT_CLOSE_TIME,
                start_break: DEFAULT_BREAK_START,
                end_break: DEFAULT_BREAK_END
            };
        }
    });
    return schedule;
})();
